import React from "react";
import Badge from "@/components/ui/Badge";
const DocStatusBadge = (props) => {
    if (props.status === 'training') {
        return (<Badge
            label="training"
            className="bg-primary-500 text-primary-500 bg-opacity-[0.12]"
        />)
    }

    if (props.status === 'trained') {
        return (<Badge
            label="trained"
            className="bg-success-500 text-success-500 bg-opacity-[0.12]"
        />)
    }

    return (<Badge
        label="new"
        className="bg-secondary-500 text-secondary-500 bg-opacity-[0.2]"
    />)
}
export default DocStatusBadge